import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { TalentPoolData } from '@core/tellent-assistant-types';
import { AppKind } from '@core/tellent-types';
import { IconContainerComponent } from '@core/user-interface-legacy';

import { injectAssistantLinkTarget } from '../../assistant-link-target';
import { ListCardComponent } from '../../list-card/list-card.component';

@Component({
  selector: 'rt-list-item-talent-pool',
  imports: [ListCardComponent, IconContainerComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-talent-pool.component.html',
  styleUrl: './list-item-talent-pool.component.less',
})
export class ListItemTalentPoolComponent {
  private readonly buildLinkTarget = injectAssistantLinkTarget();

  protected readonly linkTarget = computed(() =>
    this.buildLinkTarget(AppKind.Recruitee, {
      id: 'talentPool',
      params: { talentPoolId: this.data().slug },
    }),
  );

  public readonly data = input.required<TalentPoolData>();
}
